export const COMMON_TYPES = {
    CAPTION_CLASSES: ['text-caption', 'd-block', 'grey--text', 'text--darken-2', 'my-1'],
}
